<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg4 xl3>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <br>
                  <img src="/static/logo.png" alt="Logo" width="240">
                  <h3 class="flex my-4 primary--text">Nhập mật khẩu mới</h3>
                </div>
                <v-form v-model="form.valid" ref="form">
                  <v-text-field
                    append-icon="lock"
                    name="login"
                    label="Mật khẩu mới"
                    type="password"
                    v-model="form.newPassword"
                    :rules="[validate.required, validate.min]"
                    @keydown.enter.prevent="submit()"
                  ></v-text-field>
                  <br>
                  <v-btn
                    block
                    round
                    color="black"
                    :loading="isLoading"
                    class="login-btn"
                    @click="submit()"
                  >Hoàn thành</v-btn>
                  <br>
                  <v-layout align-center justify-center>
                    <v-btn flat small to="/login">Quay lại đăng nhập</v-btn>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import validate from '@/utils/validate';
import { mapActions, mapGetters } from 'vuex';

export default {
  data: () => ({
    validate: validate,
    isLoading: false,
    form: {
      valid: false,
      newPassword: ''
    }
  }),
  computed: {
    email () {
      return this.$store.state.user.forgotPasswordEmail;
    },
    phone () {
      return this.$store.state.user.forgotPasswordPhone;
    },
    otp () {
      return this.$store.state.user.forgotPasswordOTP;
    }
  },
  methods: {
    ...mapActions(['forgotPassword']),
    submit () {
      if (this.form.valid) {
        if (this.email) this.form.email = this.email;
        if (this.phone) this.form.phone = this.phone;
        this.form.otp = this.otp;
        this.forgotPassword(this.form)
          .then(res => {
            this.isLoading = false;
            window.getApp.showMessage('Lấy lại mật khẩu thành công');
            window.location.href = `#/login`;
          })
          .catch(_ => {
            this.isLoading = false;
            let message = 'Có lỗi xảy ra, vui lòng thử lại';
            window.getApp.showMessage(message, 'error');
          });
      } else {
        this.$refs.form.validate();
      }
    }
  }
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.login-btn {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/forgotpassword/ConfirmPassword.vue